import React from "react";

import { loadingPropTypes } from "../../../propTypes";
import styles from "./Loading.module.scss";

/**
 * Loading - Animated SVG loading indicator component displaying "EVPOS" text with letter-by-letter
 * animation. Creates smooth wave-like animation with staggered timing for each letter (E=0s, V=0.07s,
 * P=0.15s, O=0.22s, S=0.3s). Used throughout the application to indicate data fetching, processing,
 * or loading states. Responsive SVG that scales with parent container.
 *
 * @component
 * @returns {JSX.Element} Animated SVG loading indicator with wave effect
 */
export default function Loading() {
  return (
    <div className={styles["loading-container"]}>
      <svg width="300" height="100" viewBox="0 0 300 100" xmlns="http://www.w3.org/2000/svg">
        <text x="10" y="50" className={styles["loading-container__letter"]} style={{ animationDelay: "0s" }}>
          E
        </text>
        <text x="60" y="50" className={styles["loading-container__letter"]} style={{ animationDelay: "0.07s" }}>
          V
        </text>
        <text x="110" y="50" className={styles["loading-container__letter"]} style={{ animationDelay: "0.15s" }}>
          P
        </text>
        <text x="160" y="50" className={styles["loading-container__letter"]} style={{ animationDelay: "0.22s" }}>
          O
        </text>
        <text x="210" y="50" className={styles["loading-container__letter"]} style={{ animationDelay: "0.3s" }}>
          S
        </text>
      </svg>
    </div>
  );
}

Loading.propTypes = loadingPropTypes;
